import {BRIX_OPTIONPICKER_IMG_CLASSNAME, ID_WEBCHAT_BODY, ID_WEBCHAT_OUTPUT} from 'Container/Ui/constants';
import {OPTION_PICKER_IMAGE_TEXT_CLASSNAME, OPTION_PICKER_TEXT_TEXT_CLASSNAME} from '@vfde-brix/option-picker';
import {scrolldown} from '../../../components/scrolldown';

/**
 * Scrolls when all images in option pickers are loadad (or if we don't
 * have any option picker image at all)
 *
 * @param scrollToLongBubble
 * @param chatBubblesWrapperId
 */
export const scrollWebchatContent = (chatBubblesWrapperId: string) => {

    const chatBubbleElement = document.getElementById(chatBubblesWrapperId) as HTMLElement;
    const webchatBody = document.getElementById(ID_WEBCHAT_BODY) as HTMLElement;

    const containerBody = document.getElementById(ID_WEBCHAT_OUTPUT);
    const optionPickerImages = containerBody.getElementsByClassName(BRIX_OPTIONPICKER_IMG_CLASSNAME);
    const countOptionPickerImages = optionPickerImages.length;

    // no Images in Webchat Output? Then "Promise.all()" will be solved immediately
    const promiseArray = [];

    // collect all Option Picker Images in Webchat Output
    for (let i = 0; i < countOptionPickerImages; i++) {
        const imgPromise = new Promise( function (resolve, reject) {
            const optionPickerImage: HTMLImageElement = <HTMLImageElement> optionPickerImages[i];
            if (optionPickerImage.complete) {
                // image is already loaded => resolve now!
                resolve('already loaded');
            } else {
                // resolve, when images is loaded
                optionPickerImage.onload = (e) => {
                    resolve('fully loaded');
                };
            }
        });
        promiseArray.push(imgPromise);
    }

    // if all Option Picker Imiges will be loaded (or we don't habe any option picker)
    // scroll will be called
    Promise.all(promiseArray)
        .then( () => {
            const scrollToLongResponse = chatBubbleElement?.clientHeight >= webchatBody.clientHeight;
            if (scrollToLongResponse && 0 < chatBubblesWrapperId.length) {
                // scroll to the top of long text bubble
                document.getElementById(chatBubblesWrapperId).scrollIntoView({block: 'start', behavior: 'smooth'});
            } else {
                // scroll down after message has been rendered
                scrolldown();
            }
        });

};
